import { render, staticRenderFns } from "./Problems.vue?vue&type=template&id=ba2418a2&scoped=true&"
import script from "./Problems.vue?vue&type=script&lang=ts&"
export * from "./Problems.vue?vue&type=script&lang=ts&"
import style0 from "./Problems.vue?vue&type=style&index=0&id=ba2418a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba2418a2",
  null
  
)

export default component.exports